import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { AssetFragment } from '../../graphql/asset.graphql';
import { Asset } from '../../types/asset/asset';
import { useAppDispatch } from '../../ui/pages/store';
import { assetSlice } from '../../providers/AssetProvider';

const assetSubscription = gql`
  subscription assetNotification($companyId: String!) {
    assetNotification(companyId: $companyId) {
      companyId
      entities {
        ...Asset
      }
      topic
      date
    }
  }
  ${AssetFragment.asset}
`;

export class AssetNotificationResponse extends forNotification<Asset>('assetNotification') {}

export default function AssetNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: assetNotification } = useSubscription<AssetNotificationResponse>(assetSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleAssetNotification = (notification?: AssetNotificationResponse) => {
    if (!notification?.assetNotification) return;
    const assetNotification = notification.assetNotification;

    switch (assetNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(assetSlice.actions.add(assetNotification.entities));
        break;
      case 'DELETE':
        dispatch(assetSlice.actions.delete(assetNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleAssetNotification(assetNotification);
  }, [assetNotification]);

  return <></>;
}
